import { render, staticRenderFns } from "./AdvanceRequisiteReadonly.vue?vue&type=template&id=f10217fc&"
import script from "./AdvanceRequisiteReadonly.vue?vue&type=script&lang=js&"
export * from "./AdvanceRequisiteReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports